<div class="position-relative">
  <div class="container-fluid statistics-container">
    <div class="row">
      <div class="col-60">
        <div class="container">
          <div class="row py-4 py-md-5">
            <div class="col-60 col-md-30 col-lg-15" *ngFor="let item of items">
              <div class="d-flex flex-column justify-content-center align-items-center py-4 py-md-5">
                <h3 class="elsa-title-font statistic-item-value" [appAnimatedDigit]="item.value"></h3>
                <span class="statistic-item-label text-uppercase text-center">{{item.title}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="statistics-img"></div>
</div>
